<p>logs works!</p>
